<p>logs works!</p>
